import React, {useState} from 'react';
import styles from './GroundLightNav.styl'
import Image from './ui/features/Image.jsx'
import GroundLightVersion from './ui/features/Version/GroundLightVersion.jsx'

const LIGHTNING = 'lightning'
const GROUND = 'ground'

const GroundLightNav = ({onLightCalcConfigurator, onGroundSelectConfigurator, onGroundCalcCalcConfigurator}) =>{

	// ++ Стейты
	const [showMainSec, setShowMainSec] = useState(true)
	const [addSection, setAddSection] = useState('')
	// -- Стейты


	// ++ Логика

	const openLight = () => {
		setShowMainSec(false)
		setAddSection(LIGHTNING)
	}
	const openLC = () => {
		onLightCalcConfigurator()
	}

	const openGround = () => {
		setShowMainSec(false)
		setAddSection(GROUND)
	}
	const openGS = () => {
		onGroundSelectConfigurator()
	}
	const openGC = () => {
		onGroundCalcCalcConfigurator()
	}

	const backBtn = () => { setShowMainSec(true) }

	// -- Логика

	// ++ Рендер

	const openSection = () => {
		switch (addSection){
			case LIGHTNING:
				return openLightSec()
			case GROUND:
				return openGroundSec()
		}
	}

	const openGroundSec = () => {

		let elements = []

		elements.push(<h1
			key={'light'+elements.length}
			style={{
				textAlign: 'center',
				marginTop: '3rem'
			}}
		>
			Заземление
		</h1>)

		elements.push(<button
			key={'ground'+elements.length}
			className={styles.navigation}
			onClick={openGC}
			style={{
				top: '125px',
				left: '45px'
			}}
		>Расчет
		</button>)

		elements.push(<button
			key={'ground'+elements.length}
			className={styles.navigation}
			onClick={openGS}
			style={{
				top: '125px',
				right: '45px'
			}}
		>Подбор оборудования
		</button>)

		elements.push(<button
			key={'ground'+elements.length}
			className={styles.back}
			onClick={backBtn}
			style={{
				top: '260px',
				right: '45px'
			}}
		>Назад
		</button>)

		return elements

	}
	const openLightSec = () => {
		let elements = []

		elements.push(<h1
			key={'light'+elements.length}
			style={{
				textAlign: 'center',
				marginTop: '3rem'
			}}
		>
			Молниезащита
		</h1>)

		elements.push(<button
			key={'light'+elements.length}
			className={styles.navigation}
			onClick={openLC}
			style={{
				top: '125px',
				left: '45px'
			}}
		>Расчет</button>)

		elements.push(<button
			className={styles.not_active}
			key={'light'+elements.length}
			style={{
				top: '125px',
				right: '45px'
			}}
		>Раздел находится <br/> в разрботке
		</button>)

		elements.push(<button
			key={'light'+elements.length}
			className={styles.back}
			onClick={backBtn}
			style={{
				top: '260px',
				right: '45px'
			}}
		>Назад
		</button>)

		return elements
	}

	// -- Рендер



	return(<div className={styles.cfg}>
		{/*Белый фон и лого*/}
		<div style={{position: 'absolute', margin: '0 auto', backgroundColor: '#fff', width: '18%', height: '80px'}}/>
		<Image
			className={styles.logo}
			blockChangeScale={true}
		/>
		{/*Оранжевый фон заголовка*/}
		<div style={{margin: '0 auto', backgroundColor: '#ffcc3f', width: '100%', height: '80px'}}>
			<div className={styles.title}>ИМПУЛЬС</div>
		</div>

		<div
			style={{
				position: 'absolute',
				margin: '0 auto',
				width: '740px',
				height: '320px',
				top: '100px',
				left: '20px',
				backgroundColor: '#fff'
			}}
			>

			<div className={styles.background}/>
				{
					showMainSec
						?
						<React.Fragment>
							<button
								className={styles.navigation}
								onClick={openGround}
								style={{
									top: '125px',
									left: '45px'
								}}
							>Заземление
							</button>
							<button
								className={styles.navigation}
								onClick={openLight}
								style={{
									top: '125px',
									right: '45px'
								}}
							>Молниезащита
							</button>
						</React.Fragment>
						:
						openSection()


				}
		</div>


		{/*Нижняя плашка*/}
		{/* На основной сайт IEK */}
		<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '20px', top: '450px'}}/>
		<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>
		<span className={styles.feedBack}>Почта для связи: kiselevav@iek.ru</span>
		<div style={{
			position: 'absolute',
			top: '453px',
			left: '735px',
			zIndex: '15'
		}}>
			<GroundLightVersion />
		</div>
		{/* Техническая поддержка */}
		<div style={{
			position: 'absolute',
			backgroundColor: '#ffcc3f',
			width: '50%',
			height: '20px',
			top: '450px',
			left: '390px'
		}}/>
		<a style={{
			position: 'absolute',
			top: '453px',
			left: '145px',
			color: '#3c4e50',
			width: '141px',
			height: '14px'
		}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
		</a>
		<span className={styles.techSupport}>+7 (495) 542-22-27</span>

	</div>)

}

export default GroundLightNav



// WEBPACK FOOTER //
// ./src/react/GroundLightNav.jsx